/* UnsubscribePage — public page linked from re-engagement emails. */
import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Mail } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading");  // loading | ok | error
  const [email, setEmail] = useState(null);

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    axios.get(`${API}/leads/unsubscribe`, { params: { token } })
      .then(({ data }) => {
        setEmail(data.email);
        setStatus("ok");
      })
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F0F9FF] via-[#FAFBFC] to-[#F0FDF4] px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        {status === "loading" && (
          <>
            <div className="w-12 h-12 rounded-full border-4 border-[#0EA5E9]/20 border-t-[#0EA5E9] animate-spin mx-auto mb-4" />
            <p className="text-sm text-gray-500">Обработваме заявката…</p>
          </>
        )}
        {status === "ok" && (
          <>
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-emerald-100 mb-4">
              <CheckCircle2 className="w-7 h-7 text-emerald-600" />
            </div>
            <h1 className="text-xl font-bold text-[#1A1A2E] mb-2" data-testid="unsubscribe-success">Отписахте се успешно</h1>
            <p className="text-sm text-gray-600 mb-4">
              Повече няма да получавате напомнящи имейли от Nutramilo на{" "}
              <span className="font-medium">{email}</span>.
            </p>
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#0EA5E9] hover:underline">
              <Mail className="w-4 h-4" /> Върнете се на началната страница
            </Link>
          </>
        )}
        {status === "error" && (
          <>
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-rose-100 mb-4">
              <XCircle className="w-7 h-7 text-rose-600" />
            </div>
            <h1 className="text-xl font-bold text-[#1A1A2E] mb-2" data-testid="unsubscribe-error">Невалиден линк</h1>
            <p className="text-sm text-gray-600 mb-4">
              Линкът е невалиден или е изтекъл. За помощ ни пишете на support@nutramilo.com.
            </p>
            <Link to="/" className="text-sm text-[#0EA5E9] hover:underline">Върнете се на началната страница</Link>
          </>
        )}
      </div>
    </div>
  );
}
